/* eslint-disable camelcase */
import React from 'react';
import { Box, StackView, Typography, List } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const LandingText = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    wirelessLandingText: {
      headerText1,
      unorderedListItem1,
      unorderedListItem2,
      unorderedListItem3,
      unorderedListItem3_1,
      unorderedListItem3_2,
      unorderedListItem3_3,
      headerText2,
      orderedListItem1,
      orderedListItem2,
      orderedListItem3,
      orderedListItem4,
      orderedListItem4_1Strong,
      orderedListItem4_1
    }
  } = localizedStrings;

  return (
    <>
      <Box tag="section" space={2} flex={1}>
        <StackView space={3}>
          <Typography variant={{ bold: true }}>{headerText1}</Typography>
          <List>
            <List.Item>{unorderedListItem1}</List.Item>
            <List.Item>{unorderedListItem2}</List.Item>
            <List.Item>
              {unorderedListItem3}
              <List>
                <List.Item>{unorderedListItem3_1}</List.Item>
                <List.Item>{unorderedListItem3_2}</List.Item>
                <List.Item>{unorderedListItem3_3}</List.Item>
              </List>
            </List.Item>
          </List>
          <Typography variant={{ bold: true }}>{headerText2}</Typography>
          <List variant={{ ordered: true }}>
            <List.Item>{orderedListItem1}</List.Item>
            <List.Item>{orderedListItem2}</List.Item>
            <List.Item>{orderedListItem3}</List.Item>
            <List.Item>
              {orderedListItem4}
              <List>
                <List.Item>
                  <Typography variant={{ bold: true }}>{orderedListItem4_1Strong}</Typography>
                  {orderedListItem4_1}
                </List.Item>
              </List>
            </List.Item>
          </List>
        </StackView>
      </Box>
    </>
  );
};

export default LandingText;
